export default {
      id: "top-shape-usage",
      viewBox: "0 0 1920 238",
      url: "../../assets/" + "sprite.svg#top-shape-usage",
      toString: function () {
        return this.url;
      }
    }